import { FormSection } from '@/components'
import { PageHeader } from '@/components/PageHeader/PageHeader.tsx'
import UploadColumn from '@/features/routing/components/layout/create/UploadColumn'
import i18n from '@/i18n'
import { Box } from '@mui/material'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

export const Route = createFileRoute(
  '/_authenticated/$companySlug/route-planning/import'
)({
  beforeLoad: ({ context }) => {
    context.auth.rejectIfMissingPermissions(['ROUTING_READ', 'ROUTING_WRITE'])
  },
  component: RouteComponent,
  head: () => ({
    meta: [{ title: i18n.t('routes:routes.route-planning_import.main.titlepage') }]
  })
})

function RouteComponent() {
  const { t } = useTranslation('_routes')
  const { history } = useRouter()
  const navigate = Route.useNavigate()

  const fleetList = [{ id: 'lyon', label: 'LYON HUB' }]
  const [fleetName, setFleetName] = useState<string>(fleetList[0].label)
  const [files, setFiles] = useState<File[]>([])

  const handleFilesAccepted = (acceptedFiles: File[]) => {
    setFiles(acceptedFiles)
    console.log('Fichiers importés :', acceptedFiles)
  }

  const handleManageRoutes = () => {
    navigate({
      to: '/$companySlug/route-planning/assignment'
    })
  }

  const handleDownload = () => {
    const link = document.createElement('a')
    link.href = '/route_planning_template.xlsx' // accessible depuis public/
    link.download = 'route_planning_template.xlsx'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }

  return (
    <>
      <PageHeader
        backArrow={{ historyBack: true }}
        subtitle={t('routes.route-planning_import.main.abstract')}
      >
        {t('routes.route-planning_import.main.mainTitle')}
      </PageHeader>

      <Box sx={{ my: 6, ml: { xs: 0, md: 4 } }}>
        <FormSection
          title={t('routes.route-planning_import.main.leftColumn.title')}
          description={t('routes.route-planning_import.main.leftColumn.description')}
        >
          <UploadColumn
            fleetName={fleetName}
            fleetList={fleetList}
            onFleetChange={v => setFleetName(v)}
            files={files}
            onFilesAccepted={handleFilesAccepted}
            onFileRemove={i => setFiles(prev => prev.filter((_, idx) => idx !== i))}
            onDownload={handleDownload}
            onCancel={history.back}
            onConfirm={handleManageRoutes}
          />
        </FormSection>
      </Box>
    </>
  )
}
